"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pistoia": {
    "158cf523": [{
      "hkey": "47cbf95c",
      "slug": "masiano-bottegone",
      "name": "Masiano-Bottegone",
      "primary": true,
      "skipSearch": false
    }],
    "bottegone": [{
      "hkey": "47cbf95c",
      "slug": "masiano-bottegone",
      "name": "Masiano-Bottegone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6884e5bc": [{
      "hkey": "4e733795",
      "slug": "stadio",
      "name": "Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "casermette": [{
      "hkey": "4e733795",
      "slug": "stadio",
      "name": "Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "8fc752dd": [{
      "hkey": "db9d192a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "centrale": [{
      "hkey": "db9d192a",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "136060c9": [{
      "hkey": "d922baad",
      "slug": "cireglio-piastre-cassarese",
      "name": "Cireglio-Piastre-Cassarese",
      "primary": true,
      "skipSearch": false
    }],
    "cireglio": [{
      "hkey": "d922baad",
      "slug": "cireglio-piastre-cassarese",
      "name": "Cireglio-Piastre-Cassarese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8fb886ca": [{
      "hkey": "d922baad",
      "slug": "cireglio-piastre-cassarese",
      "name": "Cireglio-Piastre-Cassarese",
      "primary": true,
      "skipSearch": false
    }],
    "le-piastre": [{
      "hkey": "d922baad",
      "slug": "cireglio-piastre-cassarese",
      "name": "Cireglio-Piastre-Cassarese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "087f563f": [{
      "hkey": "c05c1cf6",
      "slug": "san-felice-piteccio",
      "name": "San Felice-Piteccio",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "c05c1cf6",
      "slug": "san-felice-piteccio",
      "name": "San Felice-Piteccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "dfa7cf4f": [{
      "hkey": "473dc446",
      "slug": "sant-agostino",
      "name": "Sant'Agostino",
      "primary": true,
      "skipSearch": false
    }],
    "pistoia-est": [{
      "hkey": "473dc446",
      "slug": "sant-agostino",
      "name": "Sant'Agostino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "8aa7aa4b": [{
      "hkey": "e2d65cd6",
      "slug": "capostrada",
      "name": "Capostrada",
      "primary": true,
      "skipSearch": false
    }],
    "pistoia-nord": [{
      "hkey": "e2d65cd6",
      "slug": "capostrada",
      "name": "Capostrada",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "52535d9b": [{
      "hkey": "4e733795",
      "slug": "stadio",
      "name": "Stadio",
      "primary": true,
      "skipSearch": false
    }],
    "pistoia-stadio": [{
      "hkey": "4e733795",
      "slug": "stadio",
      "name": "Stadio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "024a9714": [{
      "hkey": "cf79b8cf",
      "slug": "vergine",
      "name": "Vergine",
      "primary": true,
      "skipSearch": false
    }],
    "pistoia-sud": [{
      "hkey": "cf79b8cf",
      "slug": "vergine",
      "name": "Vergine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "56850cfe": [{
      "hkey": "07a4c856",
      "slug": "barile-spazzavento-pontelungo",
      "name": "Barile-Spazzavento-Pontelungo",
      "primary": true,
      "skipSearch": false
    }],
    "pontelungo": [{
      "hkey": "07a4c856",
      "slug": "barile-spazzavento-pontelungo",
      "name": "Barile-Spazzavento-Pontelungo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "34181c35": [{
      "hkey": "c05c1cf6",
      "slug": "san-felice-piteccio",
      "name": "San Felice-Piteccio",
      "primary": true,
      "skipSearch": false
    }],
    "san-felice": [{
      "hkey": "c05c1cf6",
      "slug": "san-felice-piteccio",
      "name": "San Felice-Piteccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "75335927": [{
      "hkey": "492a0ebe",
      "slug": "santomoro-ponzano",
      "name": "Santomoro-Ponzano",
      "primary": true,
      "skipSearch": false
    }],
    "santomoro": [{
      "hkey": "492a0ebe",
      "slug": "santomoro-ponzano",
      "name": "Santomoro-Ponzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d39f30e5": [{
      "hkey": "3696c0be",
      "slug": "pistoia",
      "name": "Pistoia",
      "primary": true,
      "skipSearch": false
    }],
    "serravalle-p-se": [{
      "hkey": "3696c0be",
      "slug": "pistoia",
      "name": "Pistoia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d05629f4": [{
      "hkey": "07a4c856",
      "slug": "barile-spazzavento-pontelungo",
      "name": "Barile-Spazzavento-Pontelungo",
      "primary": true,
      "skipSearch": false
    }],
    "spazzavento": [{
      "hkey": "07a4c856",
      "slug": "barile-spazzavento-pontelungo",
      "name": "Barile-Spazzavento-Pontelungo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "pistoia"
    }],
    "1a6960c0": [{
      "hkey": "3696c0be",
      "slug": "pistoia",
      "name": "Pistoia",
      "primary": true,
      "skipSearch": false
    }],
    "uzzano": [{
      "hkey": "3696c0be",
      "slug": "pistoia",
      "name": "Pistoia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1f447d97": [{
      "hkey": "e73f0921",
      "slug": "valdibrana",
      "name": "Valdibrana",
      "primary": true,
      "skipSearch": false
    }],
    "valbrana": [{
      "hkey": "e73f0921",
      "slug": "valdibrana",
      "name": "Valdibrana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8ee358a6": [{
      "hkey": "89ce86f5",
      "slug": "baggio-iano-lupicciano",
      "name": "Baggio-Iano-Lupicciano",
      "primary": true,
      "skipSearch": false
    }],
    "villa-di-baggio": [{
      "hkey": "89ce86f5",
      "slug": "baggio-iano-lupicciano",
      "name": "Baggio-Iano-Lupicciano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;